import { getCategoryValueColor } from "Helpers/helpFunction";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import API from "service/API";
import { setLoading } from "store/actionReducers/LoadingStore";
import { setMarketCashflow, setMarketCashflowIndustry, setMarketCashflowStock, setMarketTrading, setMarketTransprobability, setMarketVietname, setMarketWorld, setStockTicker } from "store/actionReducers/MarketStore";

export default function useMarket() {
  const dispatch = useDispatch();

  const fetchWorld = useCallback(async ({ assetType }: { assetType: string }) => {
    dispatch(setMarketWorld(null))
    const res = await API.Market.marketWorld(assetType)
    if (res?.code === '0') {
      dispatch(setMarketWorld(res?.data))
    }
  }, []);

  const filterWorld = (data: any) => {
    let dataNew: any = {
      datetime: [],
      listChart: {}
    };

    if (data && data?.length > 0) {
      let count = 0;
      data.map((item: any, key: number) => {
        if (key < 4) {
          if (data?.[key]?.datetime && data?.[key + 1]?.datetime) {
            dataNew.datetime.push({
              first: data?.[key + 1].datetime,
              last: data?.[key].datetime,
            })
          }
        }

        if (key % 5 === 0) {
          count++;
        }
        // if (count <= 5) {
        if (dataNew.listChart?.[item?.assetNameVi]) {
          dataNew.listChart[item.assetNameVi].push({ value: parseFloat((item?.ranks).toFixed(2)), name: item.assetName })
        } else {
          dataNew.listChart[item.assetNameVi] = [];
          dataNew.listChart[item.assetNameVi].push({ value: parseFloat((item?.ranks).toFixed(2)), name: item.assetName })
        }
        // }
      })
    }

    return dataNew;
  }

  const fetchVietnam = useCallback(async ({ time }: { time: string }) => {
    const res = await API.Market.marketVietName({ time: time })
    if (res?.code === '0') {
      dispatch(setMarketVietname(res?.data))
    }
  }, []);

  const filterVietname = (data: []) => {
    let dataNew: any = {
      pe: [],
      vnindex: [],
      tradingdate: [],
    };
    if (data && data?.length > 0) {
      data.map((item: any, key: number) => {
        if (item?.tradingdate) {
          dataNew?.['tradingdate'].push(item?.tradingdate)
        }
        if (item?.pe) {
          dataNew?.['pe'].push(parseFloat(item?.pe.toFixed(2)))
        }
        if (item?.vnindex) {
          dataNew?.['vnindex'].push(parseFloat(item?.vnindex.toFixed(2)))
        }
      })
    }

    return dataNew;
  }

  const fetchTrading = useCallback(async ({ time }: { time: string }) => {
    const res = await API.Market.marketTrading({ time })
    if (res?.code === '0') {
      dispatch(setMarketTrading(res?.data))
    }
  }, []);

  const filterTrading = (data: []) => {
    let dataNew: any = {
      timestamp: [],
      vnindex: [],
      price: [],
      time: []
    };

    if (data && data?.length > 0) {
      let count = 0;
      data.map((item: any) => {
        if (count === 0) {
          item?.price && dataNew['price'].push(item?.price)
          item?.vnindex && dataNew['vnindex'].push(item?.vnindex)
          dataNew['time'].push(item?.time)
          dataNew['timestamp'].push({
            firstday: item?.firstday,
            lastday: item?.lastday,
          })
          count++;
        }
        if (count === 4) {
          item?.price && dataNew['price'].push(item?.price)
          item?.vnindex && dataNew['vnindex'].push(item?.vnindex)
          dataNew['time'].push(item?.time)
          dataNew['timestamp'].push({
            firstday: item?.firstday,
            lastday: item?.lastday,
          })
          count = 1;
        }
        count++;
        if (dataNew?.[item?.category]) {
          dataNew[item.category].push(parseFloat((item?.valuenet).toFixed(2)))
        } else {
          dataNew[item.category] = [];
          dataNew[item.category].push(parseFloat((item?.valuenet).toFixed(2)))
        }
      })
    }

    return dataNew;
  }

  const fetchCashflow = useCallback(async ({ category }: any) => {
    dispatch(setLoading({ value: 'AllCashFlow' }))
    const res = await API.Market.marketCashflow({ category: category })
    if (res?.code === '0') {
      dispatch(setMarketCashflow(res?.data))
      dispatch(setLoading({ value: 'AllCashFlow' }))
    }
  }, [])

  const filterCashflow = (data: any) => {
    let dataNew: any = []
    if (data && data.length > 0) {

      data.map((item: any, key: number) => {
        dataNew.push({
          x: item?.rankT5,
          y: item?.rankT0,
          tradingDateT0: item?.tradingDateT0,
          tradingDateT5: item?.tradingDateT5,
          name: item?.icbname,
          icbcode: item?.icbcode,
          marker: {
            fillColor: getCategoryValueColor(item?.trendingType).color,
          }
        })
      })
    }

    return dataNew
  }

  const fetchCashflowIndustry = useCallback(async (icbcode) => {
    dispatch(setMarketCashflowIndustry(null))
    const res = await API.Market.marketCashflowIndustry(icbcode)
    if (res?.code === '0') {
      dispatch(setMarketCashflowIndustry(res?.data))
    }
  }, [])

  const filterCashFlowIndustry = (data: any) => {
    let dataNew: any = {
      tradingdate: [],
      rankIndustry: [],
      rankStockNegative: [],
      rankStockPositive: [],
    }

    if (data?.rankIndustryT && data?.rankIndustryT.length > 0) {
      data?.rankIndustryT.map((item: any, key: number) => {
        dataNew.tradingdate.push({
          first: item.tradingdate,
          last: data?.rankIndustryT11[key].tradingdate,
        })
      })
    }

    const rankIndustry = filterTop5Rank(data, 'rankIndustryT', 'rankIndustryT11', '#FFEA8B', 'icbname', '1')
    const rankStockNegative = filterTop5Rank(data, 'rankStockNegativeT', 'rankStockNegativeT11', null, 'ticker', null)
    const rankStockPositive = filterTop5Rank(data, 'rankStockPositiveT', 'rankStockPositiveT11', null, 'ticker', null)

    dataNew.rankStockNegative = rankStockNegative
    dataNew.rankStockPositive = rankStockPositive
    dataNew.rankIndustry = rankIndustry

    console.log(dataNew, 'dataNews');


    return dataNew
  }

  const filterTop5Rank = (data: any, type: string, type2: string, color?: any, nameStock?: any, linePath?: any) => {
    let listRankStockPositive: any = {
    }

    if (data?.[type]) {
      data?.[type].map((item: any, key: number) => {
        if (!listRankStockPositive?.[item?.[nameStock]]) {
          listRankStockPositive[item?.[nameStock]] = {
            linePath: linePath ? linePath : getCategoryValueColor(item?.category).linePath,
            id: item?.[nameStock],
            name: item?.[nameStock],
            lineColor: color ? color : getCategoryValueColor(item?.category).color,
            data: [],
            category: item?.category
          }
        }

        let y = data?.[type]?.[key]?.cashFlowRank;
        let x = data?.[type2]?.[key]?.cashFlowRank;
        if (typeof x === 'string') {
          x = parseFloat(x)
        }
        if (typeof y === 'string') {
          y = parseFloat(y)
        }

        listRankStockPositive[item?.[nameStock]].data.push({
          x: x,
          y: y,
          lineColor: color,
          marker: { radius: 4, symbol: 'circle' },
        })
      })
    }

    Object.values(listRankStockPositive).map((item: any) => {
      item.data.map((value: any, key: any) => {
        if (key === 0) {
          value.marker = {
            fillColor: item?.lineColor,
            radius: 0,
            symbol: 'circle',
            states: {
              hover: {
                enabled: false,
                radius: 0
              }
            }
          }
        } else {
          value.marker = {
            fillColor: item?.lineColor,
            radius: 4,
            symbol: 'circle',
            states: {
              hover: {
                radius: 4
              }
            }
          }
        }
      })
    })

    return Object.values(listRankStockPositive);
  }

  const fetchCashflowStock = useCallback(async (stock) => {
    dispatch(setMarketCashflowStock(null))
    const res = await API.Market.marketCashflowStockCode(stock)
    if (res?.code === '0') {
      dispatch(setMarketCashflowStock(res?.data))
    }
  }, [])

  const filterCashflowStock = (data: any) => {
    let dataNew: any = {
      rankIndustry: [],
      rankStock: [],
      tradingdate: []
    };

    if (data?.rankIndustryT && data?.rankIndustryT.length > 0) {
      data?.rankIndustryT.map((item: any, key: number) => {
        if (key < 5)
          dataNew.tradingdate.push({
            first: data?.rankIndustryT[key]?.tradingdate,
            last: data?.rankIndustryT11[key]?.tradingdate
          })
      })
    }

    dataNew.rankIndustry = filterTop5Rank(data, 'rankIndustryT', 'rankIndustryT11', '#FFEA8B', 'icbname', '1')
    dataNew.rankStock = filterTop5Rank(data, 'rankStockT', 'rankStockT11',
      getCategoryValueColor(data?.categoryStock).color, 'ticker',
      getCategoryValueColor(data?.categoryStock).linePath)

    return dataNew
  }

  const fetchTransprobability = useCallback(async ({ category }: any) => {
    const res = await API.Market.marketTransprobability({ category: category })

    if (res?.code === '0') {
      dispatch(setMarketTransprobability(res?.data))
    }
  }, [])

  const filterTransprobability = (data: any) => {
    let dataNew: any = {
      buyPoint: [],
      sellPoint: [],
      tradingdate: []
    };

    if (data && data.length > 0) {
      data.map((item: any) => {
        dataNew.buyPoint.push(item?.buyPoint)
        dataNew.sellPoint.push(item?.sellPoint)
        dataNew.tradingdate.push(item?.tradingdate)
      })
    }

    return dataNew
  }

  const fetchStockTicker = useCallback(async (params: any) => {
    if (params?.stock) {
      const res = await API.Statistic.GetStockTicker(params?.stock, { time: params?.time });
      if (res?.code === '0') {
        dispatch(setStockTicker(res?.data))
      }
    }
  }, [])

  return {
    fetchWorld,
    filterWorld,
    fetchVietnam,
    filterVietname,
    fetchTrading,
    filterTrading,
    fetchCashflow,
    filterCashflow,
    fetchTransprobability,
    filterTransprobability,
    fetchCashflowIndustry,
    filterCashFlowIndustry,
    fetchCashflowStock,
    filterCashflowStock,
    fetchStockTicker,
  }
}